export const supportEmails = {
  PARTNER_SUPPORT: 'partnersupport@plume.com',
}
